// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17wYE","left":"styles_left__UiC0N"};